import type { GroupSearchRequest } from '@trukt/tms-api/GroupService';
import { createKey } from '../createKey';
import { GroupUserServiceKeys } from './serviceKeys';

const keyHandler = createKey('group');

export const GroupServiceKeys = {
  key: keyHandler.key,
  user: GroupUserServiceKeys,
  search: keyHandler.createMethod<GroupSearchRequest>(),
};
